export function roundToTwoDecimals(n) {
    return Math.round(n * 100) / 100;
}
